




























































































import { Component, Prop, Vue } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import {
  LearningUnitProgressSession as ILearningUnitProgressSession,
  LearningUnitProgressSessionStatusEnum as UnitStatus
} from "@/api-v2/course/models/learning-unit-progress-session";
import moment from "moment";
import TextField from "@/components/form/CustomPage/textField.vue";
import { translateUnitStatus } from "@/utils/session-unit-status";

@Component({
  components: { TextField, CustomTableCol, CustomTableItem }
})
export default class LearningUnitProgressTableItem extends Vue {
  @Prop() unit!: any;
  uniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  get dates() {
    const started = this.unit.sessions?.map((_: ILearningUnitProgressSession) =>
      moment(_.startedAt).toDate()
    );

    const finished = this.unit.sessions
      ?.map((_: ILearningUnitProgressSession) =>
        _.isFinished ? moment(_.finishedAt)?.toDate() : undefined
      )
      ?.filter((el: Date | undefined) => el);

    const min = started ? new Date(Math.min(...started)) : undefined;
    const max = finished?.length ? new Date(Math.max(...finished)) : undefined;

    return {
      started: min
        ? moment(min).format("lll")
        : this.$tc(this.$translate.Started),
      finished: max
        ? moment(max).format("lll")
        : this.$tc(this.$translate.Completed)
    };
  }

  get status() {
    return this.unit?.sessions?.some(
      (_: ILearningUnitProgressSession) =>
        _.status === UnitStatus.CompletedAndPassed ||
        _.status === UnitStatus.Completed ||
        _.status === UnitStatus.Passed
    );
  }

  get isFinished() {
    return this.unit.sessions?.some(
      (_: ILearningUnitProgressSession) => _.isFinished
    );
  }

  translateStatus(value: string) {
    return translateUnitStatus(value);
  }

  getTestDuration(duration: string) {
    return moment.duration(duration).humanize();
  }

  getSessionTime(startedAt: Date, finishedAt: Date) {
    const end = moment(finishedAt);
    const start = moment(startedAt);
    return moment.duration(start.diff(end)).humanize();
  }
}
